export const emptyArray: any = Object.freeze([]);

export const emptyObject: {} = Object.freeze({});
